import { BsLinkedin } from 'react-icons/bs'
import { FaGithub } from 'react-icons/fa'
import { FiInstagram } from 'react-icons/fi'
import { SiCodechef, SiGeeksforgeeks, SiHackerrank, SiLeetcode, SiTwitter } from 'react-icons/si'

const socialProfiles = [
  {
    id: 1,
    name: 'LinkedIn',
    link: 'https://www.linkedin.com/in/rajgupta2003/',
    icon: <BsLinkedin />
  },
  {
    id: 2,
    name: 'Github',
    link: 'https://github.com/code-raj11903',
    icon: <FaGithub />
  }
]

const codingProfiles = [
  {
    id: 1,
    name: 'Leetcode',
    link: 'https://leetcode.com/u/code_raj11903/',
    icon: <SiLeetcode />
  },
  {
    id: 2,
    name: 'Codechef',
    link: 'https://www.codechef.com/users/code_raj11903',
    icon: <SiCodechef />
  },
  {
    id: 3,
    name: 'Codechef',
    link: 'https://www.codechef.com/users/gupta_raj',
    icon: <SiCodechef />
  }
]

export { socialProfiles, codingProfiles }
